import { apiJson } from "./client";

/**
 * @param {string} [sportType]
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function getTournaments(sportType) {
  const query = sportType ? { sportType } : undefined;
  return apiJson("/api/Tournaments", { method: "GET", auth: false, query });
}

/**
 * @param {number} id
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function getTournamentById(id) {
  return apiJson(`/api/Tournaments/${id}`, { method: "GET", auth: false });
}

/**
 * @param {object} body
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function createTournament(body) {
  return apiJson("/api/Tournaments", { method: "POST", body, auth: true });
}

/**
 * @param {number} id
 * @param {object} body
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function updateTournament(id, body) {
  return apiJson(`/api/Tournaments/${id}`, { method: "PUT", body, auth: true });
}

/**
 * @param {number} id
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function deleteTournament(id) {
  return apiJson(`/api/Tournaments/${id}`, { method: "DELETE", auth: true });
}

/**
 * @param {number} id
 * @returns {Promise<import("./client").ApiJsonResult>}
 */
export function joinTournament(id) {
  return apiJson(`/api/Tournaments/${id}/join`, { method: "POST", auth: true });
}

/** Normalize API row for list cards (handles PascalCase from some serializers). */
export function mapTournamentFromApi(t) {
  if (!t || typeof t !== "object") return null;
  const id = t.tournamentId ?? t.TournamentId;
  if (id == null) return null;
  const createdByUserIdRaw = t.createdByUserId ?? t.CreatedByUserId;
  const createdByUserId =
    createdByUserIdRaw == null || createdByUserIdRaw === ""
      ? null
      : Number(createdByUserIdRaw);
  const td = t.tournamentDate ?? t.TournamentDate;
  let dateStr = "";
  if (typeof td === "string") {
    dateStr = td.slice(0, 10);
  } else if (td instanceof Date) {
    dateStr = td.toISOString().slice(0, 10);
  } else if (td) {
    try {
      dateStr = new Date(td).toISOString().slice(0, 10);
    } catch {
      dateStr = "";
    }
  }
  const rawLat = t.latitude ?? t.Latitude;
  const rawLng = t.longitude ?? t.Longitude;
  const latitude =
    rawLat === undefined || rawLat === null || rawLat === "" ? null : Number(rawLat);
  const longitude =
    rawLng === undefined || rawLng === null || rawLng === "" ? null : Number(rawLng);

  return {
    id,
    name: String(t.name ?? t.Name ?? ""),
    sportType: String(t.sportType ?? t.SportType ?? ""),
    date: dateStr,
    location: String(t.location ?? t.Location ?? ""),
    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null,
    placeId: String(t.placeId ?? t.PlaceId ?? ""),
    entryFee: t.entryFee ?? t.EntryFee ?? 0,
    teamSlots: Number(t.teamSlots ?? t.TeamSlots ?? 0),
    registeredTeams: Number(t.registeredTeams ?? t.RegisteredTeams ?? 0),
    currentUserIsRegistered: Boolean(t.currentUserIsRegistered ?? t.CurrentUserIsRegistered),
    createdByUserId: Number.isFinite(createdByUserId) ? createdByUserId : null,
    prizeFirst: String(t.prizeFirst ?? t.PrizeFirst ?? ""),
    prizeSecond: String(t.prizeSecond ?? t.PrizeSecond ?? ""),
    prizeThird:
      t.prizeThird != null && String(t.prizeThird ?? t.PrizeThird).trim() !== ""
        ? String(t.prizeThird ?? t.PrizeThird)
        : null,
    createdByUsername: t.createdByUsername ?? t.CreatedByUsername ?? null
  };
}
